<template>
    <card type="frame">

        <div class="tinymce" v-if="!canEdit"
            v-html="value.scenario">
        </div>

        <div v-else>
            <h3 class="text-uppercase mb-3">{{ $t('logs.scenario') }}</h3>

            <div class="pb-4">
                <editor v-model="value.scenario"></editor>
            </div>

            <div class="text-center">
                <base-button native-type="submit" type="primary" :loading="recording" @click="submit">
                    {{ $t('common.save') }}
                </base-button>
            </div>
        </div>
    </card>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
            loading: {
                type: Boolean,
                default: false
            },
            recording: {
                type: Boolean,
                default: false
            },
            simulation: {
                type: Object,
                required: true
            },
            degree: {
                type: Object,
                required: true
            },
        },

        computed: {
            
            shared() {
                return this.degree.shared && this.$auth.user.owner_id && this.$auth.user.owner_id != this.degree.owner_id
            },

            canEdit() {
                return !this.shared && this.degree.status != 'archived'
            },
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
